export const ENDPOINT = {
  AUTH: {
    LOGIN: '/auth/sign-in',
    LOGOUT: '/auth/logout',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    CHECK_RESET_PASSWORD: '/auth/check-reset-password',
    REFRESH_TOKEN: '/auth/refresh-token',
  },
  USER: {
    GET_ME: '/users/me',
    GET_LIST: '/users',
    GET_DETAIL: '/users/:id',
    UPDATE: '/users/:id',
  },
  POST: {
    GET_LIST: '/posts',
    GET_DETAIL: '/posts/:id',
    GET_FUKUMARU_DETAIL: '/posts/fukumaru/:id',
    UPDATE_FUKUMARU: '/posts/fukumaru/:id',
    DELETE_FUKUMARU: '/posts/fukumaru/:id',
  },
  POST_FUKUMARU: {
    GET_LIST: '/posts',
    GET_DETAIL: '/posts/fukumaru/:id',
    UPDATE: '/posts/fukumaru/:id',
    DELETE: '/posts/fukumaru/:id',
  },
  CALENDAR_POST: {
    GET_LIST: '/posts',
    GET_DETAIL: '/posts/calendar-post/:id',
    CREATE: '/posts/calendar-post',
    UPDATE: '/posts/calendar-post/:id',
    DELETE: '/posts/calendar-post/:id',
  },
  ARTICLE: {
    GET_LIST: '/articles',
    GET_DETAIL: '/articles/:id',
    CREATE: '/articles',
    UPDATE: '/articles/:id',
    DELETE: '/articles/:id',
    GET_CATEGORIES: '/articles/categories',
    GET_TAGS: '/articles/tags',
    GET_OFFERS: '/articles/offers',
    GET_APP_EVENTS: '/articles/events',
    GET_CHECKBOX_LIST: '/articles/checkbox-list',
  },
  AYUMI: {
    GET_LIST: '/ayumi/topics',
    GET_KEYS: '/ayumi/topics/keys',
    GET_DETAIL: '/ayumi/topics/:id',
    CREATE: '/ayumi/topics',
    UPDATE_KNOW: '/ayumi/topics/:id',
    UPDATE_STATUS: '/ayumi/topics/:id/status',
    DELETE: '/ayumi/topics/:id',
    CREATE_CATEGORY: '/ayumi/topics/:id/categories',
    UPDATE_CATEGORY: '/ayumi/topics/:id/categories/:categoryId',
    DELETE_CATEGORY: '/ayumi/topics/:id/categories/:categoryId',
    REORDER_CATEGORIES: '/ayumi/topics/:id/categories/order',
    GET_INTRO_VIDEO: '/ayumi/intro-video',
    UPDATE_INTRO_VIDEO: '/ayumi/intro-video',
    // 課題一覧の紹介動画（複数本）。導入ボトムシートの intro-video（単数）とは別物
    GET_INTRO_VIDEOS: '/ayumi/intro-videos',
    CREATE_INTRO_VIDEO_ITEM: '/ayumi/intro-videos',
    UPDATE_INTRO_VIDEO_ITEM: '/ayumi/intro-videos/:id',
    DELETE_INTRO_VIDEO_ITEM: '/ayumi/intro-videos/:id',
    REORDER_INTRO_VIDEOS: '/ayumi/intro-videos/order',
  },
  CATEGORY: {
    GET_ALL: '/categories/all',
    GET_LIST: '/categories',
    GET_DETAIL: '/categories/:id',
    CREATE: '/categories',
    UPDATE: '/categories/:id',
    DELETE: '/categories/:id',
    EXISTS: '/categories/exists',
  },
  ILLUSTRATION_THEME: {
    GET_LIST: '/illustration-themes',
    GET_DETAIL: '/illustration-themes/:id',
    CREATE: '/illustration-themes',
    UPDATE: '/illustration-themes/:id',
    DELETE: '/illustration-themes/:id',
    PREVIEW_IMAGE: '/illustration-themes/preview-image',
  },
  COGEVO_STAMP_IMAGE: {
    GET_LIST: '/cogevo-stamp-images',
    GET_DETAIL: '/cogevo-stamp-images/:id',
    CREATE: '/cogevo-stamp-images',
    UPDATE: '/cogevo-stamp-images/:id',
    DELETE: '/cogevo-stamp-images/:id',
  },
  TAG: {
    GET_LIST: '/tags',
  },
  SPECIAL_DAY: {
    GET_LIST: '/special-days',
    GET_DETAIL: '/special-days/:id',
    CREATE: '/special-days/',
    UPDATE: '/special-days/:id',
    DELETE: '/special-days/:id',
  },
  NOTIFICATION: {
    GET_LIST: '/notifications',
    GET_DETAIL: '/notifications/:id',
    CREATE: '/notifications',
    UPDATE: '/notifications/:id',
    DELETE: '/notifications/:id',
  },
  PROMPT: {
    GET_LIST: '/prompts',
    GET_DETAIL: '/prompts/:id',
    CREATE: '/prompts/',
    UPDATE: '/prompts/:id',
    DELETE: '/prompts/:id',
  },
  PROMPT_INPUT_TYPE: {
    GET_LIST: '/prompt-input-types',
  },
  PROMPT_KEY_GROUP: {
    GET_LIST: '/prompt-key-groups',
    GET_DETAIL: '/prompt-key-groups/:id',
    CREATE: '/prompt-key-groups/',
    UPDATE: '/prompt-key-groups/:id',
    DELETE: '/prompt-key-groups/:id',
  },
  EVENT: {
    GET_LIST: '/events',
    GET_FOR_SELECT: '/events/find',
    GET_DETAIL: '/events/:id',
    CREATE: '/events',
    UPDATE: '/events/:id',
    DELETE: '/events/:id',
  },
  BANNER: {
    GET_LIST: '/banners',
    GET_DETAIL: '/banners/:id',
    CREATE: '/banners',
    UPDATE: '/banners/:id',
    DELETE: '/banners/:id',
  },
  CHAT_FUKUMARU: {
    GET_LIST: '/chat-fukumaru',
    GET_DETAIL: '/chat-fukumaru/:id',
    CREATE: '/chat-fukumaru',
    UPDATE: '/chat-fukumaru/:id',
    DELETE: '/chat-fukumaru/:id',
  },
  IMAGE: {
    GET_URL: '/uploads/presigned-url/:id',
  },
  UPLOAD: {
    UPLOAD_FILE: '/uploads',
    UPLOAD_VIDEO: '/uploads/video',
  },
  SCREEN_MEDIA: {
    GET_LIST: '/screen-medias',
    GET_DETAIL: '/screen-medias/:id',
    CREATE: '/screen-medias',
    UPDATE: '/screen-medias/:id',
    UPDATE_STATUS: '/screen-medias/:id/status',
    UPDATE_ORDER: '/screen-medias/order',
    ROTATION_PREVIEW: '/screen-medias/rotation-preview',
    DELETE: '/screen-medias/:id',
  },
  COMMENT: {
    GET_LIST: '/comments',
    DELETE: '/comments/:id',
  },
  ZIPCODE: {
    GET_DETAIL: '/japan-posts/zip-code/:id',
  },
  USER_REPORT: {
    GET_LIST: '/user-reports',
  },
  POST_REPORT: {
    GET_LIST: '/post-reports',
  },
  CONTENT: {
    GET_LIST: '/contents',
    GET_DETAIL: '/contents/:id',
    CREATE: '/contents',
    UPDATE: '/contents/:id',
    DELETE: '/contents/:id',
  },
  OFFER: {
    GET_LIST: '/offers',
    GET_DETAIL: '/offers/:id',
    CREATE: '/offers',
    UPDATE: '/offers/:id',
    DELETE: '/offers/:id',
    GET_FOR_SELECT: '/offers/find',
    GET_CHECKBOX_LIST: '/offers/checkbox-list',
  },
  SURVEY: {
    GET_LIST: '/surveys',
    GET_DETAIL: '/surveys/:id',
    CREATE: '/surveys',
    UPDATE: '/surveys/:id',
    DELETE: '/surveys/:id',
  },
  NOTIFICATION_REMIND: {
    GET_LIST: '/notifications-remind',
    GET_DETAIL: '/notifications-remind/:id',
    CREATE: '/notifications-remind',
    UPDATE: '/notifications-remind/:id',
    DELETE: '/notifications-remind/:id',
  },
  SURVEY_HEALTH: {
    GET_LIST: '/surveys-health',
    GET_DETAIL: '/surveys-health/:id',
    CREATE: '/surveys-health',
    UPDATE: '/surveys-health/:id',
    DELETE: '/surveys-health/:id',
  },
  SURVEY_HEALTH_QUESTION: {
    GET_LIST: '/surveys-health-question',
    GET_DETAIL: '/surveys-health-question/:id',
    CREATE: '/surveys-health-question',
    UPDATE: '/surveys-health-question/:id',
    DELETE: '/surveys-health-question/:id',
  },
  APP_VERSION: {
    GET_LIST: '/app-version-settings',
    GET_DETAIL: '/app-version-settings/:id',
    CREATE: '/app-version-settings/',
    UPDATE: '/app-version-settings/:id',
    DELETE: '/app-version-settings/:id',
  },
  PARTNER: {
    GET_LIST: '/partners',
    GET_DETAIL: '/partners/:id',
    CREATE: '/partners',
    UPDATE: '/partners/:id',
    DELETE: '/partners/:id',
  },
  COMPANY: {
    GET_LIST: '/companies',
    GET_DETAIL: '/companies/:id',
    GET_ARTICLES: '/companies/list-articles',
    CREATE: '/companies',
    UPDATE: '/companies/:id',
    CHECK_INVITE_CODE: '/companies/check-invite-code',
    CHANGE_STATUS: '/companies/:id/change-status',
  },
  INQUIRY: {
    GET_LIST: '/inquiries',
    GET_DETAIL: '/inquiries/:id',
    UPDATE_STATUS: '/inquiries/:id/update-status',
  },
  FUKUMARU_QUIZ: {
    GET_LIST: '/fukumaru-quizzes',
    GET_DETAIL: '/fukumaru-quizzes/:id',
    CREATE: '/fukumaru-quizzes',
    UPDATE: '/fukumaru-quizzes/:id',
    DELETE: '/fukumaru-quizzes/:id',
  },
  GAME_INTRODUCTION: {
    GET_LIST: '/game-introductions',
    GET_DETAIL: '/game-introductions/:id',
    CREATE: '/game-introductions',
    UPDATE: '/game-introductions/:id',
    DELETE: '/game-introductions/:id',
  },
  KAZOKUGOTO: {
    GENERATE_DAILY: '/kazokugoto/items',
    GENERATION_JOB: '/kazokugoto/items/jobs/:id',
    LIST_ITEMS: '/kazokugoto/items',
    GET_ITEM_GENERATION_LOG: '/kazokugoto/items/:id/generation-log',
    REGENERATE_COVER: '/kazokugoto/items/:id/cover',
    UPDATE_ITEM_STATUS: '/kazokugoto/items/:id/status',
    LIST_PROMPTS: '/kazokugoto/prompts',
    GET_PROMPT_BY_KEY: '/kazokugoto/prompts/:key',
    CREATE_PROMPT: '/kazokugoto/prompts',
    ACTIVATE_PROMPT: '/kazokugoto/prompts/:key/activate',
    LIST_CHARACTERS: '/kazokugoto/characters',
    CREATE_CHARACTER: '/kazokugoto/characters',
    UPDATE_CHARACTER: '/kazokugoto/characters/:id',
    UPLOAD_CHARACTER_AVATAR: '/kazokugoto/characters/:id/avatar',
    LIST_TOPICS: '/kazokugoto/topics',
    UPDATE_TOPIC: '/kazokugoto/topics/:id',
    LIST_DUOS: '/kazokugoto/duos',
    UPDATE_DUO: '/kazokugoto/duos/:dayOfWeek',
  },
  FAMILY: {
    LIST: '/families',
  },
  AGENT: {
    LIST_ENGINES: '/agent/engines',
    HENKA_COVERAGE: '/agent/henka/coverage',
    HENKA_RUNS: '/agent/henka/runs',
    START_RUN: '/agent/runs',
    RUN_PROFILE_NUDGE: '/agent/profile-nudge/run',
    RUN_JOB: '/agent/runs/:id',
    LIST_FAMILIES: '/agent/families',
    LIST_FAMILY_MEMBERS: '/agent/families/:id/members',
    LIST_MESSAGES: '/agent/messages',
    GET_MESSAGE: '/agent/messages/:id',
    GET_MESSAGE_GENERATION_LOG: '/agent/messages/:id/generation-log',
    LIST_SETTINGS: '/agent/settings',
    UPSERT_SETTING: '/agent/settings',
    LIST_PROMPTS: '/agent/prompts',
    GET_PROMPT_BY_KEY: '/agent/prompts/:key',
    CREATE_PROMPT: '/agent/prompts',
    ACTIVATE_PROMPT: '/agent/prompts/:key/activate',
  },
  KPI: {
    LIST: '/dashboard/kpi',
    LATEST: '/dashboard/kpi/latest',
    FAMILY_COHORTS: '/dashboard/kpi/family-cohorts',
  },
  KPI_INITIATIVE: {
    GET_LIST: '/dashboard/initiatives',
    CREATE: '/dashboard/initiatives',
    UPDATE: '/dashboard/initiatives/:id',
    DELETE: '/dashboard/initiatives/:id',
  },
  COMPANY_REPORT: {
    GET: '/dashboard/company-report',
    COMPANIES: '/dashboard/company-report/companies',
    FAMILIES: '/dashboard/company-report/families',
  },
  KPI_APP_USAGE: {
    GET_LIST: '/dashboard/app-usage',
    IMPORT: '/dashboard/app-usage',
    DELETE: '/dashboard/app-usage',
  },
  ADMIN_USER: {
    GET_LIST: '/users/admins',
    UPDATE_ACCESS: '/users/:id/admin-access',
  },
};
